import type { IconData } from '@stacksjs/iconify-core'

export const magicWand1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3.622 39.618c-.646-1.592.14-3.273 1.425-4.411l22.839-20.228c.84-.745 1.983-1.13 2.992-.635c.515.252 1.088.62 1.623 1.156a6 6 0 0 1 1.156 1.623c.494 1.008.11 2.15-.635 2.991L12.794 42.953c-1.14 1.285-2.82 2.071-4.412 1.425A8.6 8.6 0 0 1 5.52 42.48a8.6 8.6 0 0 1-1.898-2.862\"/><path d=\"M28.137 25.63c-.98-.933-2.026-1.953-3.142-3.07a181 181 0 0 1-2.635-2.687M21 7l3 3m14 14l3 3m0-20l-3 3m-7-7.142V7.1m9.9 9.9h4.242\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default magicWand1
